import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ProgressBar } from 'react-bootstrap'; // Asegúrate de tener instalado react-bootstrap
import DashboardCard from '../../components/TituloDashboard';
import studentPhoto from '../../img/user-profile.png';
import FiltroPeriodoEscolar from '../../components/filtroperiodoescolarEstudianteNotasVista';
import util from '../../utils/generalFunctions';
import organizacionAcademicaService from '../../services/organizacionAcademicaService';
import moment from 'moment';
import estudiantesService from '../../services/estudiantesService';
import evaluativeScaleService from '../../services/evaluativeScaleService';
import collectionsService from '../../services/collectionsService';
import "../../css/tabla-notas-viewEstudiantes.css";
import reportsService from '../../services/reportsService';
import { toast } from 'react-toastify';


const NotasEstudiantePc = () => {
  const studentInfo = util.getStudentInformation();
  const [listaAsignaturas, setListaAsignaturas] = useState([]);
  const [listaNotas, setListaNotas] = useState([]);
  const [notas, setNotas] = useState(null);
  const [evaluationScale, setEvaluationScale] = useState([]);
  const [decimalesPlanilla, setDecimalesPlanilla] = useState(0);
  const filteReference = useRef(null);
  const [showRecuperation, setShowRecuperation] = useState(false);
  const [searchRecuperation, setSearchRecuperation] = useState(false);
  const detalleRef = useRef(null); // Ref para hacer scroll al detalle de la asignatura
  let listaNotasTemp = [];
  
  
  
  
  //
  const [formData, setFormData] = useState({
    periodId:'',
    schoolSubjectId:'',
  });

  
  // Función para seleccionar asignatura y hacer scroll
  const seleccionarAsignatura = (asignatura) => {
    setFormData((prevState) => ({
      ...prevState,
      schoolSubjectId: asignatura.schoolSubjectId,
    }));

    // Hacer scroll al detalle
    setTimeout(() => {
      detalleRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300); // Pequeña espera para asegurar el render
  };

  const fetchLoadGeneralParams = async () => {
    try {
      const parameters = await collectionsService.getParameters();
      const decimales = parameters.find(
        (op) => String(op.keyName) === "decimalesPlanilla"
      );
      if (decimales) {
        setDecimalesPlanilla(Number(decimales.value));
      }
    } catch (error) {
      console.error("Error al obtener parametros de formulario:", error);
    }
  };

  const fetchLoadAsignaturas = async () => {
    const courseId = studentInfo.courseId;
    const schoolYearId = studentInfo.schoolYearId;
    const evaluationTypeId = studentInfo.evaluationTypeId;
    try{
      await fetchLoadGeneralParams();
      const evaluationScale = await evaluativeScaleService.getEvaluativeScale(evaluationTypeId,schoolYearId);
      setEvaluationScale(evaluationScale);

      await cargarListaNotas();
      const asignaturas = await organizacionAcademicaService.getAcademicOrganizationsByCourse(courseId, schoolYearId);
      setListaAsignaturas(asignaturas);

      if(asignaturas!=null && asignaturas.length>0){
        setFormData(prevState => ({
          ...prevState,
          schoolSubjectId:asignaturas[0].schoolSubjectId
        }));
      }
    }catch(ex){
      console.error("Error al obtener listas de asignaturas:", ex);
    }
  }

  const updateForm = async (data)  => {
    setFormData(prevState => ({
        ...prevState,
        periodId:data
      }));
  }

  useEffect(() => {
    cargarNotas();

  }, [formData]);

  const cargarNotas= async () =>{
    await cargarListaNotas();
    if(formData.schoolSubjectId!=='' && formData.periodId!==''){   
      const result = await reportsService.getPermisosEstudiantes(
        studentInfo.studentId,
        studentInfo.schoolYearId,
        formData.periodId
      ); // Obtenemos los estudiantes de tu sistema
          const permiso = result.find(d=>d.reportTypeId===2 && d.visible===true);
      if(permiso){
        const studentId = studentInfo.studentId;
        const courseId = studentInfo.courseId;
        const schoolYearId = studentInfo.schoolYearId;
        try{
          const recuperation = searchRecuperation?1:0;
          const resultNotas = await estudiantesService.getEstudianteNota(studentId, courseId, formData.schoolSubjectId, schoolYearId, formData.periodId, recuperation);
          if(resultNotas && resultNotas.length > 0 ){
            const item = resultNotas[0];
            setNotas(item);
            console.log(item);
          }else{
            setNotas([]);
          }
          
          const lostEstudiantes = await estudiantesService.getEstudianteToNivelar(
            studentId,
            courseId,
            schoolYearId,
            formData.periodId
          ); // Obtenemos los estudiantes de tu sistema
          const estContent = lostEstudiantes.students.find(e=>e.studentId === studentId);
          if(estContent){
            const recuperation = estContent.areasNotes.filter(a=> a.subjectNotes && a.subjectNotes.length > 0);
            setShowRecuperation(recuperation.length>0);
          }

        }catch(ex){
          console.error("Error al obtener listas de asignaturas:", ex);
        }
      }
    }
  }

  const showMensajePermiso = () => {
    toast.info("Reporte no habilitado para este período", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
}

  const cargarListaNotas= async () =>{
    if(formData.periodId!==''){
      
      const result = await reportsService.getPermisosEstudiantes(
        studentInfo.studentId,
        studentInfo.schoolYearId,
        formData.periodId
      ); // Obtenemos los estudiantes de tu sistema
          const permiso = result.find(d=>d.reportTypeId===2 && d.visible===true);
          if(permiso){
          const studentId = studentInfo.studentId;
          const courseId = studentInfo.courseId;
          const schoolYearId = studentInfo.schoolYearId;
          try{
            const recuperation = searchRecuperation?1:0;
            const resultNotas = await estudiantesService.getEstudianteNota(studentId, courseId, "", schoolYearId, formData.periodId,recuperation);
            if(resultNotas && resultNotas.length > 0 ){
              setListaNotas(resultNotas);
              listaNotasTemp=resultNotas;
            }else{
              setListaNotas([]);
            }
          }catch(ex){
            console.error("Error al obtener listas de asignaturas:", ex);
          }
        }else{
          showMensajePermiso();
          setNotas([]);
        } 
    }
  }

  useEffect(() => {
    const listaAsig = util.copy(listaAsignaturas);
    listaAsig.map(a=> {
      a.change = (a.change)?false:true;
      return a;
    });
    setListaAsignaturas(listaAsig);
  }, [notas]);

  useEffect(() => {
    cargarNotas();
  }, [searchRecuperation]);

  const getPorcetajeAsignatura= (schoolSubjectId, listaNotas) =>{
      const filtro = (listaNotasTemp.length > 0)?listaNotasTemp:listaNotas;
      const asig = filtro.find(n=> n.schoolSubjectId===schoolSubjectId);
      if(asig){
        const maxScale = evaluationScale.reduce((max, scale) => {
          return (scale.maxScore > max.maxScore) ? scale : max;
        }, evaluationScale[0]);
          return (asig.note * 100)/maxScale.maxScore;
      }else{
        return 0;
      }
  }

  const getNotaAsignatura= (schoolSubjectId, listaNotas) =>{
    const filtro = (listaNotasTemp.length > 0)?listaNotasTemp:listaNotas;
    const asig = filtro.find(n=> n.schoolSubjectId===schoolSubjectId);
    if(asig && asig.note){
        return getScaleFormatText(asig.note)
    }else{
      return " - ";
    }
}

  useEffect(() => {
    fetchLoadAsignaturas();
  }, []);

  const getScaleFormat = (totalNota) => {
    if(totalNota){
      const total = util.roundNumber(totalNota, decimalesPlanilla);
      const scale = evaluationScale.find(
        (s) => total >= s.minScore && total <= s.maxScore
      );

      if (scale) {
        return (
          <span style={{ color: scale.color }}>
            {total + " - " + scale.abbreviation}
          </span>
        );
      } else {
        return <span>{total}</span>;
      }
    }else{
      return <span> - </span>;
    }
  };

  const getScaleFormatText = (totalNota) => {
    if(totalNota){
      const total = util.roundNumber(totalNota, decimalesPlanilla);
      const scale = evaluationScale.find(
        (s) => total >= s.minScore && total <= s.maxScore
      );

      if (scale) {
        return total + " - " + scale.abbreviation;
      } else {
        return total;
      }
    }else{
      return " - ";
    }
  };

  return (
    <div className="container-fluid p-4">
      {/* Botón de regreso */}
      <div className="mb-3">
        <Link to="/dashboard" className="back-to-dashboard-pc">
                                       <FontAwesomeIcon icon={faArrowLeft} />
                                   </Link> 
      </div>

      {/* Tarjeta con información del estudiante */}
      <DashboardCard studentPhoto={studentPhoto} title="Notas" subtitle="Detalles de tus notas" />

      {/* Escala de Evaluación */}
      <div className="alert alert-info text-center rounded shadow-sm p-3">
        {evaluationScale.map((scale, index) => (
          <span key={index} className="me-3">
            {scale.name}{" "}
            <strong style={{ color: scale.color }}>
              {" "}
              {scale.abbreviation + " (" + scale.minScore.toFixed(decimalesPlanilla) + " - " + scale.maxScore.toFixed(decimalesPlanilla) + ") "}
            </strong>
          </span>
        ))}
      </div>

      <div className="row">
        {/* Lista de Asignaturas */}
        <div className="col-lg-6">
          <div className="card p-3 shadow-sm lista-asig-print">
            <FiltroPeriodoEscolar schoolYearId={studentInfo.schoolYearId} callback={updateForm} ref={filteReference} />

            {/* Switch para ver notas de recuperación */}
            {showRecuperation && (
              <div className="form-check form-switch text-end my-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="chk-recuperation"
                  checked={searchRecuperation}
                  onChange={(e) => setSearchRecuperation(e.target.checked)}
                />
                <label className="form-check-label ms-2" htmlFor="chk-recuperation">Ver notas de recuperación</label>
              </div>
            )}

            <h3 className="mb-3">Asignaturas</h3>
            {listaAsignaturas.map((asignatura, index) => (
              <div key={index} className="mb-3 p-2 asignatura-item rounded shadow-sm">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">{asignatura.schoolSubjectName}</h5>
                  <button className="btn btn-outline-primary btn-sm" onClick={() => seleccionarAsignatura(asignatura)}>
                    Ver detalle <FontAwesomeIcon icon="chevron-right" />
                  </button>
                </div>
                <ProgressBar
                  variant="primary"
                  now={getPorcetajeAsignatura(asignatura.schoolSubjectId, listaNotas)}
                  label={`${getNotaAsignatura(asignatura.schoolSubjectId, listaNotas)}`}
                  onClick={() => seleccionarAsignatura(asignatura)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Detalles de la Asignatura */}
        <div className="col-lg-6">
          {formData.schoolSubjectId && notas && (
            <div className="card p-3 shadow-sm" ref={detalleRef}>  {/* 🚀 Scroll hasta aquí */}
              <h3 className="mb-3">Detalles de {listaAsignaturas.find(s => s.schoolSubjectId === formData.schoolSubjectId)?.schoolSubjectName}</h3>
              <h5 className="text-muted mb-3">Nota Definitiva: <span className="badge bg-success">{getScaleFormat(notas.note)}</span></h5>

              {notas?.processNotes?.map((proceso, index) => (
                <div key={index} className="mb-4 p-3 proceso-detalle border rounded">
                  <h5 className="mb-2">{proceso.evaluationProcessName} <span className="badge bg-info">{proceso.evaluationProcessProcentage}%</span></h5>
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Descripción</th>
                        <th>Nota</th>
                      </tr>
                    </thead>
                    <tbody>
                      {proceso?.definitionNotes?.map((evaluacion, idx) => (
                        <tr key={idx}>
                          <td>{evaluacion.notesDefinitionName} <br />
                            <small className="text-muted">{moment(evaluacion.evaluationDate).format("YYYY-MM-DD")}</small>
                          </td>
                          <td><span className="badge bg-primary">{getScaleFormat(evaluacion.note)}</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}

              <h5 className="mt-3">Nota Final de {listaAsignaturas.find(s => s.schoolSubjectId === formData.schoolSubjectId)?.schoolSubjectName}: <span className="badge bg-dark">{getScaleFormat(notas.note)}</span></h5>
            </div>
          )}
        </div>
      </div>

      {/* Estilos adicionales */}
      <style jsx>{`
        .btn-back {
          font-size: 0.9rem;
          padding: 8px 12px;
        }

        .asignatura-item {
          background: #f8f9fa;
          transition: all 0.3s ease-in-out;
        }

        .asignatura-item:hover {
          background: #e9ecef;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .proceso-detalle {
          background: #f1f3f5;
        }

        .table th, .table td {
          text-align: center;
          vertical-align: middle;
        }

        .table-bordered th, .table-bordered td {
          border: 1px solid #dee2e6;
        }
      `}</style>
    </div>
  );
};

export default NotasEstudiantePc;